import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import { FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule, FormGroup } from '@angular/forms';
import {
  GetCreditRuleItemsFn,
  CreditRuleItem,
  ConnectToOtherCreditFlowDialogData,
  ConnectToOtherCreditFlowDialogResult,
  CreditAlertStatus,
  CreditFlow,
  CreditAlertOptions,
  GetCreditFlowsFn,
} from '@portal-workspace/grow-shared-library';
import { MatButtonModule } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout/flex';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { PortalHotToastService } from '../portal-hot-toast-component/hot-toast.service';
import { ApplicationDialogService } from './application-dialog.service';

@Component({
    templateUrl: './connect-to-other-credit-flow.dialog.html',
    styleUrls: ['./connect-to-other-credit-flow.dialog.scss'],
    standalone: true,
    imports: [MatFormFieldModule, MatInputModule, MatSelectModule, FormsModule, ReactiveFormsModule, FlexModule, MatButtonModule, MatDialogModule]
})
export class ConnectToOtherCreditFlowDialog implements OnInit{
  formControlCondition!: FormControl<number | null>;
  formControlCreditFlowId!: FormControl<number | null>;
  formControlStatus!: FormControl<CreditAlertStatus | null>;
  formGroup!: FormGroup<{
    condition: FormControl<number | null>,
    creditFlowId: FormControl<number | null>,
    status: FormControl<CreditAlertStatus | null>,
  }>

  getCreditRuleItemsFn!: GetCreditRuleItemsFn;
  getCreditFlowsFn!: GetCreditFlowsFn;
  creditRuleItemOptions: CreditRuleItem[] = [];
  creditFlowOptions: CreditFlow[] = [];
  creditAlertStatusOptions = CreditAlertOptions;
  currentFlowId!: number;


  constructor(@Inject(MAT_DIALOG_DATA) public data: ConnectToOtherCreditFlowDialogData,
              private toastService: PortalHotToastService,
              private dialogService: ApplicationDialogService,
              private dialogRef: MatDialogRef<ConnectToOtherCreditFlowDialog, ConnectToOtherCreditFlowDialogResult>,
              private formBuilder: FormBuilder) {
    this.getCreditRuleItemsFn = this.data.getCreditRuleItemsFn;
    this.getCreditFlowsFn = this.data.getCreditFlowsFn;
    this.currentFlowId = this.data.currentFlowId;
    this.formControlCondition = this.formBuilder.control(this.data.condition ?? null, [Validators.required]);
    this.formControlCreditFlowId = this.formBuilder.control(this.data.creditFlowId ?? null, [Validators.required]);
    this.formControlStatus = this.formBuilder.control(this.data.status ?? null, [Validators.required]);

    this.formGroup = this.formBuilder.group({
      condition: this.formControlCondition,
      creditFlowId: this.formControlCreditFlowId,
      status: this.formControlStatus,
    });
  }

  ngOnInit(): void {
    this.getCreditRuleItemsFn().pipe(
      this.toastService.spinnerObservable(),
    ).subscribe(creditRuleItems => {
      this.creditRuleItemOptions = creditRuleItems.filter(item => item.outputType === 'Boolean');
    })

    this.getCreditFlowsFn().pipe(
      this.toastService.spinnerObservable(),
    ).subscribe(creditFlows => {
      this.creditFlowOptions = creditFlows.filter(flow => flow.id !== this.currentFlowId);
    })

  }

  onCancel() {
    this.dialogRef.close({
      readyForSubmission: false,
      clearConnection: false,
      condition: null,
      creditFlowId: null,
      status: null,
    })
  }

  onSubmit() {
    if (this.formGroup.valid) {
      this.dialogRef.close({
        readyForSubmission: true,
        clearConnection: false,
        condition: this.formControlCondition.value,
        creditFlowId: this.formControlCreditFlowId.value,
        status: this.formControlStatus.value,
      })
    }
  }

  onClear() {
    this.dialogService.openConfirmationDialog({
      message: 'Clear Connection',
      subMessage: 'Are you sure to clear the current connection?'
    }).afterClosed().subscribe((result) => {
      if (result?.readyForSubmission) {
        this.dialogRef.close({
          readyForSubmission: true,
          clearConnection: true,
          condition: this.formControlCondition.value,
          creditFlowId: this.formControlCreditFlowId.value,
          status: this.formControlStatus.value,
        })
      }
    })
  }
}
